export const MODIFIER_KEY =
	window.navigator.platform === 'MacIntel' ? 'Meta' : 'Control';
